import PeerConnectionManager from "../Services/PeerConnectionManager";
export const getUser = () => {
    return JSON.parse(localStorage.getItem("user"));
}

const currentWorkspace = () => {
    const user = getUser();
    const indexStorage = localStorage.getItem("workspaceIndex");
    const index = indexStorage ? parseInt(indexStorage) : null;

    if (
        (!indexStorage || isNaN(index) || !user.workspace[index]) &&
        user.workspace.length > 0
    ) {
        return 0;
    }

    return index ?? 0;
};
export const getWorkspaceId = () => {
    const isHost = PeerConnectionManager.isHost
    const isConnected = PeerConnectionManager.isConnected();

    // if connected and not a host use sync index instead of ws index
    if (isConnected && !isHost) {
        return "local";
    }

    const user = getUser();
    if (user && user?.workspace[currentWorkspace()]?.workspaceDTO?.id) {
        return user.workspace[currentWorkspace()].workspaceDTO.id;
    }
    return null
}